<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @selection-change="handleSelectionChange"
        @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" size="small" plain @click.stop="handleAdd(scope.row, scope.index)" v-if="permission.JOINS_SALES_CLOUD_PW_ADD">
            <i class="el-icon-plus"></i>新增
          </el-button>
          <el-button type="warning" size="small" plain v-if="permission.JOINS_SALES_CLOUD_PW_DEL"
            @click.stop="handleDel('DELETE_OPTION', '逻辑删除')">
            <i class="el-icon-delete"></i>删除
          </el-button>
          <el-button type="danger" size="small" plain v-if="permission.JOINS_SALES_CLOUD_PW_DEL"
            @click.stop="handleDel('DELETE_OPTION', '物理删除')">
            <i class="el-icon-delete"></i>物理删除
          </el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="primary" size="small" plain @click.stop="handleEdit(scope.row, scope.index)" v-if="permission.JOINS_SALES_CLOUD_MENU_ET">
            <i class="el-icon-edit"></i>编辑
          </el-button>
          <el-button type="success" size="small" plain @click.stop="handleView(scope.row, scope.index)">
            <i class="el-icon-view"></i>查看
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";
import { resolveUrlPath } from "@/util/util";
import { GoodsFormOption } from "@/const/work/waterProject/purWaterGoods";
import { findGoods, delGoods } from "@/api/work/waterProject/purWaterGoods";
import { findProject } from "@/api/work/serviceItem";
export default {
  name: "GoodsForm",
  data() {
    return {
      tableOption: GoodsFormOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      loading: false,
      superiorIds: [],
      superiorId: {},
      serviceCategoryName: {},
      categoryTypes: [],
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
    };
  },
  created() {
    findProject().then((res) => {
      let data = JSON.parse(res.data);
      this.superiorIds = data;
    });
    this.handleList();
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findGoods(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findGoods(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findGoods(params).then((res) => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size,
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      findGoods(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      let obj = {
        label: "新增净水产品",
        value: "/work/waterProject/purWaterGoods/add",
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
      });
    },
    handleEdit(row) {
      let obj = {
        label: "编辑净水产品",
        value: "/work/waterProject/purWaterGoods/edit",
        query: { GoodsId: row.id },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },
    handleView(row) {
      let obj = {
        label: "查看净水产品",
        value: "/work/waterProject/purWaterGoods/view",
        query: { GoodsId: row.id },
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query,
      });
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;
      findGoods(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map((item) => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delGoods(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
